import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { FaCartPlus } from "react-icons/fa6";
import { Link, useParams } from "react-router-dom";
import { useState, useMemo } from "react";
import { metalList } from "../../../../utils/variables";
import { moneyFormat } from "../../../../utils/functions";
import Eyebrow from "../../../../components/ui/Eyebrow";
import ChoiceChip from "../../../../components/ui/ChoiceChip";
import Price from "../../../../components/ui/Price";

export default function ProductSelection({ self_reference, name, prices, prod_time, stones }) {

    const { id } = useParams();

    const [selectedMaterial, setSelectedMaterial] = useState(1);

    const priceByMaterial = {
        1: "high_gold_price",
        2: "low_gold_price",
        3: "silver_price"
    };

    const price = useMemo(() => {
        const originalPrice = prices[priceByMaterial[selectedMaterial]];
        return moneyFormat(originalPrice);
    }, [selectedMaterial]);

    return (
        <Grid size={{ xs: 12, md: 6 }} sx={styles.gridContainer}>
            <Box sx={styles.productInfo}>
                <Eyebrow>Ref. {self_reference}</Eyebrow>
                <Typography component="h1" variant="h3" sx={styles.title}>
                    {name}
                </Typography>
                {Array.isArray(stones) && stones.length > 0 && (
                    <Box sx={{ mt: 1.5, display: 'flex', flexWrap: 'wrap', color: 'text.secondary' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, mr: 0.5 }}>
                            Pedras incluídas:
                        </Typography>
                        {stones.map((stone, idx) => (
                            <Typography key={idx} variant="body2" sx={{ mr: 0.5 }}>
                                {stone.quantity} {stone.quantity === 1 ? "unidade" : "unidades"} de {stone.variation_name}
                                {idx < stones.length - 1 ? "," : "."}
                            </Typography>
                        ))}
                    </Box>
                )}
            </Box>

            <Box sx={styles.metals}>
                <Typography sx={styles.fieldLabel}>Material</Typography>
                <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
                    {metalList.map((material) => (
                        <ChoiceChip
                            key={material.value}
                            selected={selectedMaterial === material.value}
                            onClick={() => setSelectedMaterial(material.value)}
                        >
                            {material.label}
                        </ChoiceChip>
                    ))}
                </Stack>
            </Box>

            <Box sx={styles.priceInfo}>
                <Price size="lg" component="p">{price}</Price>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {metalList.find((m) => m.value === selectedMaterial)?.label}, seu índice
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Prazo ideal de confecção: {Math.ceil(prod_time)} dias
                </Typography>
            </Box>

            <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                <Button
                    component={Link}
                    to={`/pedido-personalizado/${id}`}
                    sx={styles.actionButton}
                    variant="outlined"
                    color="primary"
                >
                    Personalizar joia
                </Button>
                <Button
                    component={Link}
                    startIcon={<FaCartPlus />}
                    variant="contained"
                    color="secondary"
                    sx={styles.actionButton}
                    to={`/pedido-especificacoes/${id}`}
                >
                    Encomendar
                </Button>
            </Stack>
        </Grid>
    );
};

const styles = {
    gridContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: '1.5rem',
    },
    productInfo: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
    },
    title: {
        textAlign: 'left',
        mt: '.35rem',
    },
    fieldLabel: {
        fontSize: '.72rem',
        letterSpacing: '.06em',
        textTransform: 'uppercase',
        color: 'text.secondary',
        fontWeight: 700,
        mb: '.6rem',
    },
    metals: {
        width: '100%',
    },
    priceInfo: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: 0.5,
    },
    actionButton: {
        width: { xs: '100%', sm: '50%' },
    },
};
